const Coin = 'HUSD';
const Coin2 = 'HT';
const Coin3 = 'HFIL';
const Coin4 = 'FIL';
const Coinxch = 'IXCH';
export default {
    Coin,
    Coin2,
    Coin3,
    Coin4,
    Coinxch
}


// WEBPACK FOOTER //
// ./src/models/coin.js